import request from '@/utils/request'

/** 启用资讯列表 */
export function getNewsArticles() {
  return request.get('/api/news-articles')
}

/** 资讯详情 */
export function getNewsArticleById(id) {
  return request.get(`/api/news-articles/${id}`)
}
